import { useEffect, useState } from 'react';
import { usePrefs } from '@/app/prefs';
import { Icon } from '@/components/ui';

/**
 * Tells staff the network dropped before they blame the app.
 *
 * On a clinic LAN this usually means the Wi-Fi or the server went away, and the
 * useful thing is to know that saving will fail *before* typing a whole invoice.
 */
export function OfflineBanner() {
  const { t } = usePrefs();
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div role="status" style={styles.bar}>
      <Icon name="alert" size={15} />
      {t.common.offline}
    </div>
  );
}

const styles = {
  bar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    padding: '8px 14px',
    background: 'var(--sn-dn-bg)',
    color: 'var(--sn-dn-fg)',
    fontSize: 12.5,
    fontWeight: 600,
  },
} satisfies Record<string, React.CSSProperties>;
